import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ItemSelectableWithOptions } from '../../ItemSelectable/ItemSelectableWithOptions';
import { t } from 'i18next';
import PeopleToVisitManagementContext from '../../../context/PeopleToVisitContext/PeopleToVisitManagementContext';

export const ListOfPeopleToVisit = ({ person, openWarningModalToDelete }) => {
    const navigate = useNavigate();

    const { setPersonToVisitData } = useContext(PeopleToVisitManagementContext);

    const goToEditPerson = async () => {
        const openingsToSelector = [];
        const buildingsToSelector = [];

        person.openings.forEach(opening => {
            openingsToSelector.push(opening.openingCode);
        });

        person.buildings.forEach(building => {
            buildingsToSelector.push(building.buildingId);
        });

        person.openingCodes = openingsToSelector;
        person.buildingIds = buildingsToSelector;
        person.sectorId = person.sector ? person.sector.sectorId : null;

        await setPersonToVisitData(person);
        navigate(`/settings/entityManagment/peopleToVisitMaganagement/edit/${person.peopleToVisitId}`);
    }

    const optionsOfPeopleToVisit = [
        {
            name: `${t('EDIT')} ${t('PERSON_TO_VISIT')}`,
            icon: 'edit-black-icon.svg',
            onClick: () => goToEditPerson(person),
        },
        {
            name: `${t('DELETE')} ${t('PERSON_TO_VISIT')}`,
            icon: 'trash-bin.svg',
            onClick: () => openWarningModalToDelete(person),
        },
    ]

    return (
        <>
            <ItemSelectableWithOptions options={optionsOfPeopleToVisit} idPopover={`peopleToVisitEdit-${person.peopleToVisitId}`}>
                <div>
                    <p className='m-0 param-section-title'>{`${person.documentNumber} - ${person.name} ${person.lastName}`}</p>
                    <p className='m-0 mt-1 param-section-subtitle'>{person.sector ? person.sector.sectorName : '-'}</p>
                </div>
            </ItemSelectableWithOptions>
        </>

    )
}
